import { render } from "./CookiesToolTip.vue?vue&type=template&id=34a31c6a&scoped=true&ts=true"
import script from "./CookiesToolTip.vue?vue&type=script&lang=ts"
export * from "./CookiesToolTip.vue?vue&type=script&lang=ts"

import "./CookiesToolTip.vue?vue&type=style&index=0&id=34a31c6a&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a31c6a"]])

export default __exports__